// @ts-strict-ignore
import { SearchResultVO } from './search-result.vo';
import { SuitableConnectionsVO } from './suitable-connections.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ConnectionSearchResultVO')
export class ConnectionSearchResultVO extends SearchResultVO {

  public static readonly CLASS_NAME: string = 'ConnectionSearchResultVO';

  @JsonProperty('connections', '[SuitableConnectionsVO]')
  public connections: SuitableConnectionsVO[] = undefined;
  @JsonProperty('queryElectedArticleIdsIncludedInCompleteSearchResult', '[Number]')
  public queryElectedArticleIdsIncludedInCompleteSearchResult: number[] = undefined;

  public constructor() {
    super();
    this.type = ConnectionSearchResultVO.CLASS_NAME;
  }
}
